import i18next from "i18next";
import { useEffect } from "react";
import { initReactI18next, useTranslation as useTranslationOriginal } from "react-i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { getOptions } from "./config";
import useStoreLanguage from "./use-store-language";

// Initialize i18next for client-side only (Vite SPA)
i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(
    resourcesToBackend(
      (language: string, namespace: string) => import(`./locales/${language}/${namespace}.json`)
    )
  )
  .init({
    ...getOptions(),
    lng: undefined, // Let browser language detector determine the language
    detection: {
      order: ["cookie", "htmlTag", "navigator"],
    },
  });

export function useTranslation(
  namespace: Parameters<typeof useTranslationOriginal>[0],
  options?: object
) {
  const { language: cookies } = useStoreLanguage();
  const originalInstance = useTranslationOriginal(namespace, options);
  const { i18n } = originalInstance;

  // Drive i18next when the user picks a language via the store.
  // Compare i18n.language (updates immediately after changeLanguage call) not
  // resolvedLanguage (async — updates only after resources finish loading, causing
  // the effect to re-fire on every render during the loading window → infinite loop).
  useEffect(() => {
    if (!cookies || i18n.language === cookies) return;
    void i18n.changeLanguage(cookies);
  }, [cookies, i18n]);

  return originalInstance;
}

export default i18next;
